import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { tomos } from '../data/constants';
import { Check, ChevronDown, Trophy, BookOpen, Target, Layers, Users, MapPin } from 'lucide-react';
export function ProductOverview() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const includes = ['Protocolo de Activación 3-2-1 listo para usar', 'Técnica detallada de Hip Thrust, Sumo y RDL', 'Vacío Abdominal para cintura más fina', 'Cardio correcto que no destruye el músculo', 'Tracker de medidas y progresión de cargas', 'Sin gimnasio obligatorio · solo elementos básicos', 'Nutrición base con alimentos argentinos reales', 'Plan completo de 30 días día por día'];
  const valueBullets = [{
    icon: BookOpen,
    label: '4 Tomos PDF'
  }, {
    icon: Target,
    label: 'Plan de 30 días'
  }, {
    icon: Layers,
    label: 'Recetario incluido'
  }, {
    icon: Check,
    label: 'Para casa o gym'
  }, {
    icon: Users,
    label: 'Resultados visibles'
  }, {
    icon: MapPin,
    label: 'Creado para argentinas'
  }];
  return <section className="py-16 md:py-24 px-4 max-w-5xl mx-auto" data-id="element-373">
      {/* SOLUTION INTRO */}
      <div className="text-center mb-12 md:mb-16" data-id="element-374">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3 flex items-center justify-center gap-2" data-id="element-375">
          <Trophy className="w-4 h-4" data-id="element-376" /> 📦 El sistema completo
        </p>
        <h2 className="text-2xl md:text-5xl font-extrabold mb-4 leading-tight max-w-3xl mx-auto" data-id="element-377">
          4 Tomos. Una progresión{' '}
          <span className="text-primary" data-id="element-378">científica y completa.</span>
        </h2>
        <p className="text-base md:text-xl text-zinc-300 max-w-3xl mx-auto leading-relaxed" data-id="element-379">
          Cada tomo construye sobre el anterior. No son PDFs sueltos. Es una
          progresión diseñada específicamente para el cuerpo femenino.
        </p>
      </div>

      {/* VALUE BULLETS GRID */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 mb-14 md:mb-16" data-id="element-380">
        {valueBullets.map(({
        icon: Icon,
        label
      }, i) => <div key={i} className="bg-surface border border-zinc-800 hover:border-primary/40 transition-colors rounded-xl p-4 md:p-5 flex items-center gap-3" data-id="element-381">
            <div className="w-9 h-9 rounded-lg bg-primary/15 border border-primary/30 flex items-center justify-center shrink-0" data-id="element-382">
              <Icon className="w-4 h-4 text-primary" data-id="element-383" />
            </div>
            <span className="text-sm md:text-base font-bold text-white leading-tight" data-id="element-384">
              {label}
            </span>
          </div>)}
      </div>

      {/* 6 TOMOS */}
      <div className="mb-14 md:mb-16" data-id="element-385">
        <div className="text-center mb-8 md:mb-10" data-id="element-386">
          <h3 className="text-2xl md:text-4xl font-extrabold mb-3 leading-tight" data-id="element-387">
            4 tomos.{' '}
            <span className="text-primary" data-id="element-388">
              Una progresión mensual completa.
            </span>
          </h3>
          <p className="text-sm md:text-base text-zinc-400" data-id="element-389">
            Tocá un tomo para ver el contenido
          </p>
        </div>

        <div className="space-y-3" data-id="element-390">
          {tomos.map((t, i) => {
          const isOpen = openIndex === i;
          return <div key={t.id} className={`rounded-2xl border overflow-hidden transition-colors duration-200 ${isOpen ? 'bg-surface border-primary shadow-[0_0_25px_rgba(249,168,212,0.15)]' : 'bg-surface border-zinc-800 hover:border-primary/40'}`} data-id="element-391">
                <button className="w-full px-5 py-4 md:px-7 md:py-5 text-left flex items-center justify-between gap-4 focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-392">
                  <div className="flex items-center gap-3 md:gap-4 min-w-0" data-id="element-393">
                    <span className="text-2xl md:text-3xl shrink-0" data-id="element-394">
                      {t.icon}
                    </span>
                    <div className="min-w-0" data-id="element-395">
                      <div className="font-bold text-white text-base md:text-lg leading-tight" data-id="element-396">
                        Tomo {i + 1} — {t.name}
                      </div>
                      <div className="text-xs md:text-sm text-primary font-medium mt-0.5" data-id="element-397">
                        {t.months}
                      </div>
                    </div>
                  </div>
                  <ChevronDown className={`w-5 h-5 text-primary shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-398" />
                </button>

                <AnimatePresence data-id="element-399">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-400">
                      <div className="px-5 pb-5 md:px-7 md:pb-6 text-zinc-300 text-sm md:text-base leading-relaxed border-t border-primary/20 pt-4" data-id="element-401">
                        {t.content}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>

      {/* WHAT EACH TOMO INCLUDES */}
      <div data-id="element-402">
        <div className="text-center mb-8 md:mb-10" data-id="element-403">
          <h3 className="text-2xl md:text-3xl font-extrabold leading-tight max-w-3xl mx-auto" data-id="element-404">
            Cada tomo viene listo para{' '}
            <span className="text-primary" data-id="element-405">aplicar y ver resultados</span>
          </h3>
        </div>

        <div className="bg-surface border border-zinc-800 rounded-2xl p-6 md:p-8" data-id="element-406">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4" data-id="element-407">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-408">
                <div className="mt-0.5 bg-primary/20 p-1 rounded-full shrink-0" data-id="element-409">
                  <Check className="w-3 h-3 text-primary" data-id="element-410" />
                </div>
                <span className="text-zinc-200 text-sm md:text-base" data-id="element-411">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}